import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const LogoutButton = (props) => {
	const {logoutfunction} = props

	return (
		<button
			onClick={() => {
				logoutfunction()
			}}>
			Log Out
		</button>
	);
};
